import { render, staticRenderFns } from "./app-default.vue?vue&type=template&id=40fcc7c6&scoped=true&"
import script from "./app-default.vue?vue&type=script&lang=js&"
export * from "./app-default.vue?vue&type=script&lang=js&"
import style0 from "./app-default.vue?vue&type=style&index=0&id=40fcc7c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fcc7c6",
  null
  
)

export default component.exports